import { Scaffold } from 'layouts';
import { ListPendingOrders } from 'components/Pages/Scheduling/PaginatedPendingOrders';
import { SchedulingLayout } from 'layouts/Scheduling';

export const ListPendingOrdersPage: React.FC = () => {
  return (
    <Scaffold>
      <SchedulingLayout>
        <ListPendingOrders />
      </SchedulingLayout>
    </Scaffold>
  );
};
